import React, { useEffect, useState } from "react";
import { Grid, Tooltip, Typography } from "@mui/material";

import style from "./index.module.css";

import defaultProfilePic from "@/assets/patient.png";

import GetImages from "@/components/GetImages";

import { IAddClinicTeamMemberEnums, ISessionKeys } from "@/models";
import { IDoctorAssociatedClinicMemberProfile } from "@/models/ApiRequestResponse/doctor";

import { transformClasses } from "@/utils";
import { storage } from "@/utils/Storage";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  setAddToCallMember,
  videoAppointmentDetails,
} from "@/store/slices/videoAppointment";
import { ipDashboardDetails } from "@/store/slices/doctor/ipDashboard";
import { chat } from "@/store/slices/chat";

interface IProps {
  type: IAddClinicTeamMemberEnums;
  showSelectedMember?: boolean;
  showCallIcon?: boolean;
}
const AddClinicTeamPatientCard: React.FC<IProps> = (props) => {
  const { type, showSelectedMember = true, showCallIcon = false } = props;

  const [list, setList] = useState<IDoctorAssociatedClinicMemberProfile[]>([]);

  const currentUserId = storage.getSessionToken(ISessionKeys.USER_ID);

  const dispatch = useAppDispatch();
  const { clinicTeams, searchedMember } = useAppSelector(
    (state) => state.doctorProfile
  );
  const { hospitalTeam } = useAppSelector(ipDashboardDetails);
  const { selectedChat } = useAppSelector(chat);

  const { addToCallMember } = useAppSelector(videoAppointmentDetails);

  const getMemberClinicTeamList = (): void => {
    switch (type) {
      case IAddClinicTeamMemberEnums.ASSOCIATED_CLINICAL_TEAM:
        setList(clinicTeams);
        return;
      case IAddClinicTeamMemberEnums.SEARCHED_MEMEBER:
        setList(searchedMember);
        return;
      case IAddClinicTeamMemberEnums.CHAT:
        setList(selectedChat?.doctor_details);
        return;
      case IAddClinicTeamMemberEnums.HOSPITAL_TEAMS:
        setList(hospitalTeam);
        return;
      default:
        return;
    }
  };

  const resetCardSelection = (event: React.MouseEvent): void => {
    event.stopPropagation();
    dispatch(setAddToCallMember(null));
  };

  useEffect(() => {
    getMemberClinicTeamList();
  }, [type, clinicTeams, searchedMember]);
  return (
    <Grid
      item
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(4, 1fr)",
          sm: "repeat(6, 1fr)",
        },
        gap: "1.2rem",
      }}
    >
      {list?.map((team, index) => (
        <Tooltip title={team?.name}>
          <Grid
            item
            key={`${team.name}-${index}`}
            className={transformClasses(
              style.card,
              showSelectedMember && addToCallMember?.userId === team.userId
                ? style.selected
                : ""
            )}
            onClick={(): void => {
              dispatch(
                setAddToCallMember({ ...team, callerId: currentUserId })
              );
            }}
          >
            {showSelectedMember && addToCallMember?.userId === team.userId && (
              <Grid
                item
                className={style.removeSelection}
                onClick={resetCardSelection}
              >
                <GetImages name="RemoveSelectionIcon" width="12" height="12" />
              </Grid>
            )}
            {showCallIcon && (
              <Grid
                item
                className={style.callIcon}
                onClick={() =>
                  (window.location.href = `tel:${team.country_code}${team.phone_number}`)
                }
              >
                <GetImages name="CallDoctorTeamIcon" width="12" height="12" />
              </Grid>
            )}
            <img
              src={
                team.profilePhoto ?? team.photo_url ?? team.profilePhoto ?? ""
              }
              alt={team.name}
              width={40}
              height={40}
              onError={(e) => (e.currentTarget.src = defaultProfilePic)}
            />
            <Grid item>
              <Typography component={"p"} className={style.name}>
                {team.name.slice(0, 5)}
                {team.name.length > 5 && "..."}
              </Typography>
              {type === IAddClinicTeamMemberEnums.HOSPITAL_TEAMS &&
                team.role && (
                  <Typography component={"p"} className={style.role}>
                    {`(${team.role})`}
                  </Typography>
                )}
            </Grid>
          </Grid>
        </Tooltip>
      ))}
    </Grid>
  );
};

export default AddClinicTeamPatientCard;
